import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/relatorio-cuidado-pessoa-hipertensao`

    return {
        paciente: {
            autocomplete(queryParms) {
                return repository.get(`${baseUrl}/autocomplete-paciente?${urlUtil.serialize(queryParms)}`)
            },
        },
        index(queryParms) {
            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
    }
}